module.exports = __webpack_public_path__ + "static/media/more_with_color.b2cbde7f.svg";